import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import "../App.css";
import { useNavigate } from "react-router-dom";
import { superadminLogin } from "../apis";
import _ from "lodash";
import PageHeader from "../components/PageHeader";
import SignInImage from "../assets/Images/SignIn.png";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [enteredEmail, setEnteredEmail] = useState("");
  const [enteredPassword, setEnteredPassword] = useState("");
  const [res, setRes] = useState({});

  const LoginButtonHandler = async () => {
    const data = await superadminLogin({
      email: enteredEmail,
      password: enteredPassword,
    });
    setRes(data.data);
  };

  useEffect(() => {
    if (res.success == true) {
      localStorage.setItem("user-info", JSON.stringify(res.userInfo));
      localStorage.setItem("user-type", "admin");
      navigate("/admin/dashboard");
    }
  }, [res]);
  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={12} md={6}>
          <Container maxWidth="sm" style={{ height: "100vh" }}>
            <PageHeader />
            <Box style={{ marginTop: "100px" }}>
              <Grid container spacing={2}>
                <span>
                  <h3 className="ml-9">Admin Sign In</h3>
                </span>
                <div className="login-form">
                  <Typography style={{ fontWeight: "bold" }}>Email</Typography>
                  <TextField
                    required
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter your email address"
                    variant="outlined"
                    onChange={(e) => setEnteredEmail(e.target.value)}
                  />
                  {!res.success ? (
                    <span className="mt-3" style={{ color: "red" }}>
                      {res.message}
                    </span>
                  ) : null}
                  <Typography style={{ fontWeight: "bold" }} className="mt-13">
                    Password
                  </Typography>
                  <TextField
                    required
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter your password"
                    variant="outlined"
                    type="password"
                    onChange={(e) => setEnteredPassword(e.target.value)}
                  />
                  {!res.success ? (
                    <span className="mt-3" style={{ color: "red" }}>
                      {res.message}
                    </span>
                  ) : null}

                  <span className="text-align-center">
                    <Button
                      variant="contained"
                      onClick={LoginButtonHandler}
                      className="mt-13 primary-button"
                      style={{ width: "100%" }}
                    >
                      Login
                    </Button>
                  </span>
                </div>
              </Grid>
            </Box>
          </Container>
        </Grid>
        <Grid item sm={12} md={6}>
          <div>
            <img
              src={SignInImage}
              style={{ width: "100%", height: "100vh" }}
              loading="lazy"
            />
            <Typography
              style={{
                position: "absolute",
                top: "75%",
                color: "white",
                fontWeight: "700",
                fontSize: "28px",
                lineHeight: "37px",
                padding: "20px",
              }}
            >
              What a great experience using Amaanat! I booked all of my services
              for my gap year through Amannat and never had any issues.{" "}
            </Typography>
            <Typography
              style={{
                position: "absolute",
                top: "90%",
                color: "white",
                fontWeight: "000",
                fontSize: "20px",
                lineHeight: "27px",
                padding: "20px",
              }}
            >
              Sara Loren
            </Typography>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default AdminLogin;
